import React, { useState } from "react";
import NumPad from "./NumPad";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";

/**
 * Tappable money field. Shows the formatted amount and opens our custom NumPad
 * in a sheet — never invokes the OS keyboard.
 */
export default function MoneyField({ label, value, onChange, testId, hint }) {
  const [open, setOpen] = useState(false);
  const [draft, setDraft] = useState(String(value ?? "0"));

  const openSheet = () => {
    setDraft(value !== undefined && value !== null && value !== "" ? String(value) : "0");
    setOpen(true);
  };

  const save = () => {
    const n = Number(draft);
    onChange(Number.isFinite(n) ? n : 0);
    setOpen(false);
  };

  const display = `$${Number(value || 0).toLocaleString("en-CA", {
    minimumFractionDigits: 2, maximumFractionDigits: 2,
  })}`;

  return (
    <>
      <button
        data-testid={testId}
        onClick={openSheet}
        type="button"
        className="w-full text-left rounded-xl bg-white border-2 border-[#E8E4DA] hover:border-[#1A5D3A] px-4 py-3 transition-colors"
      >
        {label && (
          <div className="text-[10px] tracking-[0.18em] text-[#5C7566] uppercase">{label}</div>
        )}
        <div
          className="text-3xl text-[#0D311E] tabular-nums mt-1"
          style={{ fontFamily: "'Fraunces', serif" }}
        >
          {display}
        </div>
        {hint && <div className="text-xs text-[#5C7566] mt-1">{hint}</div>}
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-sm bg-[#FDFBF7] border-[#E8E4DA]">
          <DialogTitle className="sr-only">{label || "Enter amount"}</DialogTitle>
          <DialogDescription className="sr-only">Use the on-screen keypad to enter a dollar amount.</DialogDescription>
          <div className="text-[10px] tracking-[0.18em] text-[#5C7566] uppercase">{label}</div>
          <div
            data-testid={`${testId}-draft`}
            className="text-5xl text-[#0D311E] tabular-nums mb-4"
            style={{ fontFamily: "'Fraunces', serif" }}
          >
            ${Number(draft || 0).toLocaleString("en-CA", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </div>
          <NumPad value={draft} onChange={setDraft} onDone={save} doneLabel="Save" testIdPrefix={`${testId}-pad`} />
        </DialogContent>
      </Dialog>
    </>
  );
}
